export default {
  table: {
    total: "共計",
    dataCount: "條資料",
    emptyText: "暫無資料",
    loadingText: "拼命載入中",
    columns: {
      index: "序號",
      name: "名稱",
      canvasName: "畫布名稱",
      createDate: "創建日期",
      creator: "創建人",
      updateTime: "更新時間",
      actions: "操作",
    },
    actions: {
      view: "查看",
    },
  },
};
